import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Footer.css';
import Link from '../Link';
import { ROLE_SUPER_ADMIN } from '../../constants';

class Footer extends React.Component {
  render() {
    return (
      <div className={s.root}>
        <div className={`container ${s.container}`}>
          <div className={`row`}>
            <hr className={s.line} />
            <div className="col-xs-8 col-xs-offset-1">
              <h3>ABOUT BITAA</h3>
              <div className={s.text}>
                We have filtered information from many sources in order to
                provide the best possible activities all in one place. We
                believe that children benefit the most from inquiry and
                self-directed learning.
              </div>
            </div>
            <div className="col-xs-3">
              <h3>PAGES</h3>
              <div>
                <Link to="/home">Home</Link>
              </div>
              <div>
                <Link to="/app">Bitaa App</Link>
              </div>
              <div>
                <Link to="/about">Why Bitaa?</Link>
              </div>
              <div>
                <Link to="/howto">How does it work?</Link>
              </div>
              <div>
                <Link to="/videos">Videos</Link>
              </div>
              <div>
                <Link to="/login">Log In</Link>
              </div>
              <div>
                <Link to="/contact">Contact Us</Link>
              </div>
              <div>
                <Link to="/policy">Privacy Policy</Link>
              </div>
            </div>
          </div>
          <div className={'row'}>
            <hr className={s.line} />
            <div className="col-xs-11 col-xs-offset-1">
              © 2019 BITAA TECHNOLOGY
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js